import classNames from 'classnames';
import { Link } from 'react-router-dom';

export type ReturnsSettingsTab =
  | 'policy'
  | 'returns'
  | 'exchanges'
  | 'incentives'
  | 'carriers'
  | 'approval'
  | 'notifications';

const tabs: Array<{
  id: ReturnsSettingsTab;
  label: string;
  to: string;
}> = [
  {
    id: 'policy',
    label: 'Policy',
    to: '/settings/resolution-portal/returns/policy',
  },
  {
    id: 'returns',
    label: 'Returns',
    to: '/settings/resolution-portal/returns/settings',
  },
  {
    id: 'exchanges',
    label: 'Exchanges',
    to: '/settings/resolution-portal/returns/exchanges',
  },
  {
    id: 'incentives',
    label: 'Incentives',
    to: '/settings/resolution-portal/returns/incentives',
  },
  {
    id: 'carriers',
    label: 'Shipping',
    to: '/settings/resolution-portal/returns/carriers',
  },
  {
    id: 'approval',
    label: 'Review',
    to: '/settings/resolution-portal/returns/approval',
  },
  {
    id: 'notifications',
    label: 'Notifications',
    to: '/settings/notifications?tab=returns',
  },
];

export default function ReturnsSettingsTabs({
  activeTab,
}: {
  activeTab: ReturnsSettingsTab;
}) {
  return (
    <nav
      aria-label="Returns and exchanges settings sections"
      className="bg-white rounded-xl border border-gray-200 p-1.5 shadow-sm inline-flex w-full overflow-x-auto"
    >
      {tabs.map((tab) => (
        <Link
          key={tab.id}
          to={tab.to}
          aria-current={activeTab === tab.id ? 'page' : undefined}
          className={classNames(
            'flex-1 min-w-[112px] px-4 py-2 rounded-lg text-sm transition-all whitespace-nowrap inline-flex items-center justify-center',
            activeTab === tab.id
              ? 'bg-gray-100 text-gray-900 font-semibold shadow-sm'
              : 'text-gray-500 hover:text-gray-700 font-medium hover:bg-gray-50',
          )}
        >
          {tab.label}
        </Link>
      ))}
    </nav>
  );
}
